import React from 'react';
import PropTypes from 'prop-types';

import { compact } from 'lodash';
import { Form, Modal } from 'react-bootstrap-5';

import ManagedInput from 'components/form/managed_input';
import Button from 'shared/button';

const getGroupId = (group) => {
  return group.id && group.id.toString();
};

export default class GroupFormModal extends React.Component {
  static propTypes = {
    group: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    }),
    groups: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })),
    shown: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  }

  state = {
    namesByGroupId: {}
  }

  get title() {
    const group = this.groups[0] || {};

    if (group.id) {
      const groupWord = this.groups.length === 1 ? 'Group' : 'Groups';
      return `Edit ${groupWord}`;
    } else {
      return 'Create New Group';
    }
  }

  get groups() {
    return this.props.groups || compact([this.props.group]);
  }

  canSave() {
    return Object.values(this.state.namesByGroupId).every(name => name);
  }

  handleShow = () => {
    const namesByGroupId = {};
    for (const group of this.groups) {
      namesByGroupId[getGroupId(group)] = group.name;
    }

    this.setState({ namesByGroupId });
  }

  handleChange = (changes) => {
    this.setState(state => ({ namesByGroupId: { ...state.namesByGroupId, ...changes } }));
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const groups = this.groups.map(group => ({
      ...group,
      name: this.state.namesByGroupId[getGroupId(group)]
    }));

    if (this.props.group) {
      this.props.onSubmit(groups[0]);
    } else {
      this.props.onSubmit(groups);
    }
  }

  render() {
    return (
      <Modal centered show={this.props.shown} onHide={this.props.onCancel} onShow={this.handleShow}>
        <Modal.Header closeButton>
          <Modal.Title>{this.title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form onSubmit={this.handleSubmit}>
            {this.renderNameInputs()}
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button.Cancel
            name="cancel"
            onClick={this.props.onCancel}
          >
            Cancel
          </Button.Cancel>
          <Button.Primary
            disabled={!this.canSave()}
            name="save"
            onClick={this.handleSubmit}
          >
            Save
          </Button.Primary>
        </Modal.Footer>
      </Modal>
    );
  }

  renderNameInputs() {
    return this.groups.map(group => this.renderNameInput(group));
  }

  renderNameInput(group) {
    return (
      <Form.Group key={group.id}>
        <ManagedInput
          className="form-control"
          name={getGroupId(group)}
          placeholder="Name"
          value={this.state.namesByGroupId[group.id]}
          onChange={this.handleChange}
        />
      </Form.Group>
    );
  }
}
